import {Box, Stack} from '@mui/material';
import React from 'react';
import {Outlet} from 'react-router-dom';

import {AppBarV2} from '../components/AppBar';
import SettingsNavBar from '../pages/settings/SettingsNavBar';

const SettingsLayout = () => {
  return (
    <Stack direction={'column'} height={'100vh'} width={'100vw'}>
      <AppBarV2 />

      <Box display="flex" sx={{flexGrow: 1, height: 0}}>
        <SettingsNavBar />
        <Box
          sx={{
            flexGrow: 1,
            overflow: 'auto',
            paddingTop: '90px',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Stack>
  );
};

export default SettingsLayout;
